import { useDailyEvent } from '@daily-co/daily-react';
import { addRumError, addRumAction } from '../../utils/observability/dataDog';

type DailyEvent = object & { error?: { msg: string } };

const warn = (msg: string) => (event: DailyEvent) =>
  addRumError(`[Daily] ${msg}: ${event?.error?.msg}`, event);

const info = (msg: string) => (event: DailyEvent) => addRumAction(`[Daily] ${msg}`, event);

export const useObserveDailyEvents = () => {
  /* Full list of all events: https://docs.daily.co/reference/daily-js/events */

  // Errors
  useDailyEvent('camera-error', warn('Camera Error'));
  useDailyEvent('load-attempt-failed', warn('Load attempt failed'));
  useDailyEvent('error', warn('Generic Error'));
  useDailyEvent('nonfatal-error', warn('Camera Error'));

  // Events
  useDailyEvent('participant-joined', info('Participant Joined '));
  useDailyEvent('participant-left', info('Participant Left'));
  useDailyEvent('track-started', info('Track Started'));
  useDailyEvent('track-stopped', info('Track Stopped'));
  useDailyEvent('network-quality-change', info('Quality change'));
};
